import { environment } from '../../../../../environments/environment';
export const site = {

  /** DEV */
  website: environment.website,
  displayWebsite: environment.displayWebsite,
  email: environment.email,
  apiHost: environment.apiHost,
  apiHostDev: environment.apiHostDev,
  customerUrl: environment.customerUrl,
  displayCusUrl: environment.displayCusUrl,
  wpCouponSite: environment.wpCouponSite,
  picStories: environment.picStories,

}


export const spekwo = {
  spekwo: 'speKwo',
  phoneNumber: 'O. 866.646.0200',
  logoQuote: 'Instant quotes & reliable repairs for all items on your home inspection',
  website: site.website,
  displayWebsite: site.displayWebsite,
  customerUrl: site.customerUrl,
  displayCusUrl: site.displayCusUrl,
  email: site.email,
  picStories: site.picStories,

  // SMS
  hiMsge: "Hello ",
  smsDefaultContent1: "This is a courtesy message from speKwo. Your solution estimate has been completed and is in your email inbox.",
  smsDefaultContent2: "Please contact our office with any question or to schedule repairs.",
  smsDefaultContent3: "Thank you",
  smsDefaultContent4: "speKwo Team",
  smsDefaultContent5: '"Instant quotes and reliable repairs for all items on your home inspection."',
  smsDefaultContent6: "PS- Please check your spam or junk mail if it is not showing in your inbox.",

  logoUrlHome: 'assets/images/logos/speKwo_logo.png',
  logoUrl: 'assets/images/logos/spekwo.png',
  logoUrl1: 'assets/images/logos/logo-image.png',
  spekWalk: 'SpeK-Walk Summary Review',
  spekCall: 'SpeK-Call Summary Review',
  prouct1: 'HIQFULL',
  prouct2: 'INSPECTIONCALL',
  prouct3: 'GCCONSULTING',
  prouct4: 'CGPYWCK',
  prouct5: 'RJCZPSJ',
  'All Users': 'All Users',
  'Owner': 'Owner',
  'Solution Estimate': 'Solution Estimate',
  'speK ExeC': 'speK ExeC',
  'Senior Estimator': 'Senior Estimator',
  'Estimator': 'Estimator',
  'Spekwo Manager': 'speKwo Manager',
  'Pro': 'Pro',
  'HIQFULL': 'Full Spekwo',
  'GCCONSULTING': 'Walk and Talk',
  'INSPECTIONCALL': 'SpeK - Call',
  'RJCZPSJ': 'The Pre-List speK-Sheet',
  'CGPYWCK': 'Specific Item speKwo',
  'Seller': 'Seller',
  "Seller Agent": "Seller Agent",
  "Buyer Agent": "Buyer Agent",
  "Buyer": "Buyer",
  "Buyer Broker": "Buyer Broker",
  "Seller Broker": "Seller Broker",
  "Buyer TM": "Buyer TM",
  "Seller TM": "Seller TM",

  defaultUrl: 'assets/images/avatars/profile.jpg',
  defaultImg: 'assets/images/avatars/default.jpg',
  defaultLogo: 'assets/images/avatars/default.jpg',
  productImg: 'assets/images/ecommerce/product-image-placeholder.png',
  defaultStory: 'assets/images/avatars/blank.png',
  getFilterOrderBody: `
  {
    nodes{
      id
      nodeId
      clientphone
      clientemail
      archive
      firstName
      lastName
      indrole
      agentrole
      statusId
      longitude
      latitude
      couponId
      couponByCouponId{
        couponAmount
      }
      productId
      productByProductId{
        productId
        productName
        productPrice
        sku
      }
      duedate
      stripeinvoicesByOrderId{
        nodes{
          orderId
          invoiceid
          chargeObject
          invoiceObject
        }
      }
      claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          claimOrderId
          orderId
          statusId
          userId
          roleId
          statusByStatusId{
            statusName
            displayStatus
          }
          roleByRoleId {
            roleName
          }
          userByUserId {
            firstName
            lastName
          }
        }
      }
      firmByFirmId{
        firmsName
      }
      officeByOfficeId{
        officesName
      }
      marketByMarketId{
        marketName
      }
      orderContent
      orderedDate
      createdAt
       inspectionReportsSrcByOrderId {
              id
             orderId
             insReportId
             reportReviewDetailsByInsReportId(first: 1) {
               edges {
                 node {
                   orderId
                   reviewId
                 }
               }
             }
             scheduleRequestByScheduleRequestId {
               id
               createdAt
               statusId
               statusChangeAt
               scheduleRequestDate
               nodeId
               userByAcceptedBy {
                 firstName
                 lastName
                 email
               }
             }
             solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
               nodes{
                 roleid
                 roleByRoleid{
                   roleId
                   roleName
                 }
                 userByUserid {
                   userId
                   firstName
                   lastName
                 }
                 createdat
               }
             }

             reportSolutionMastersByInsReportId(first: 1) {
               nodes {
                 createdAt
                 id
               }
             }
       }
         orderStatusesByOrderId(orderBy:ID_DESC,first:1){
               nodes {
                 orderId
                 statusId
                 statusByStatusId {
                   statusId
                   statusName
                 }
           }
         }
   }
    totalCount
 }
}`,
}
export const checkoutFields = {
  'createdVia': "checkout",
  'spekwoPage': '_tmcartepo_data',
  'deliveryTime': 'Delivery Time',
  'pdfContainer': '5cee82233ac0e3.86242120',


  'agentRole': 'billing_myfield1',
  'buyerProperty': 'billing_myfield2',
  'propertyRole': 'billing_myfield15',
  'clientName': 'billing_myfield23',
  'solEmail': 'billing_myfield24',
  'itemList': 'item_list',
  'agentName': 'billing_agent_name',
  'agentEmail': 'billing_agent_email',

  'homeInspectionReport': 'homeInspection',
  'preListPicture': 'picUpload',
  'ddra': 'ddra',
  'uniqueReport': 'uniqueReport',
  'supportReport': 'supportReport',
  'supportingReport': 'supportingReport',
  'wdoReport': 'wdoReport',
  'structEngReport': 'structEngReport',
  'wellReport': 'wellReport',


  'specificKey1': '1-20 Items', //spekwo
  'specificKey2': '21-40 Items',//spekwo
  'specificKey3': '41-60 Items',//spekwo
  'walkInspectItems1': 'Areas to Inspect (Max 3, included in price)', //walktalk
  'walkInspectItems2': 'Additional items to Inspect (Additional $10 per category)',//walktalk
  'apptDate': 'myfield2',//spekcall & walktalk

  'customInvoiceClientName': 'custom_invoice_client_firstname',
  'customInvoiceClientEmail': 'custom_invoice_client_email',
  'trashOrderStatus': '_wp_trash_meta_status',

  invoiceCompleteStatus: 'completed',//from php

  archiveCompleteStatus: 'success', //from php
  archiveFailedStatus: 'failed', //from php
  //list
  archivedOrdersCompleteStatus: 'success', //from php
  archivedOrdersFailedStatus: 'failed', //from php

  checkOrdersCompleteStatus: 'success', //from php


  ocrDumpFetchStatus: 'completed', //from php,

  updateOrderStatusSuccess: 'success',//from php,
  updateOrderStatusFailed: 'failed',


  uploadCompanyLogoSuccess: 'completed',//from php,
  uploadCompanyLogoFailed: 'failed',

  // 'pdfContainer': '5d04d096d88c29.99106636',
  fullSpekwoItems: "full-spekwo-items",
  homeInspection: 'PDF - Home Inspection ',
  ddraReport: 'PDF - DDRA',
  wdo: 'wdoReport',
  structuralEng: 'structEngReport',
  well: 'wellReport'
}

export const stripeStatus = {
  'open': 'open',
  'paid': 'paid'
}
export const host = site.apiHost;
export const hostDev = site.apiHostDev;

export const apiCalls = {

  apiId: 'AIzaSyCMAIvTjuT1nIw_dJv3cRnsbIPSyeMMRRo',
  channelId: 'UCTvtTeyyF3hQ8hJv97Gj_Ag',
  fbPost: 'https://www.facebook.com/SpeKwo-344051736111918/',
  bugTrack: 'https://bugtracker.zoho.com/portal/spekwo#myfeed',
  youtubeApi: 'https://www.googleapis.com/youtube/v3/search?key=',
  customOrder: site.website + 'custom-order-creation-for-spekwo',
  wpCouponSite: site.wpCouponSite,

  profileUrl: host + 'profiles/',
  logoUrl: host + 'logos/',

  ocrDocumentUrl: host + 'uploads/',
  ocrDocFetch: host + 'getOcrDocument.php',

  wcOrders: host + 'orders.php',
  wcOrdersTest: host + 'checkOrders.php',
  updateOrder: host + 'update_order.php?dev=true',
  attachment: host + 'attachment.php',
  getUploadDocumentUrls: host + 'getUploadFilesUrl.php',
  uploadStartUrl: host + 'profileDocuments/',

  ocrResponse: host + 'OCR_Response.php',
  getSolutionType: host + 'spreadsheet/getSolutionType.php',
  getDescCost: host + 'spreadsheet/getDescCost.php',
  payment: host + 'payment.php',
  manualUpload: host + 'manualUpload.php',
  manualFileProcessing: host + 'manualFileProcessing.php',

  sendMail: host + 'sendMail.php',

  sendSMS: host + 'sendSMS.php',
  sendSMSBETA: hostDev + 'sendSMSBeta.php',
  passReportIdToClient: host + 'passReportIdToClient.php',
  // uploadToYoutube: 'http://172.104.179.88/SpekwoRest/uploadToYoutubeFinal.php',
  uploadToYoutube: host + 'uploadToYoutubeFinal.php',
  stripeInvToCustomer: host + 'invoiceCheck.php',
  getAllInvoicesWithCharges: host + 'getAllStripeInvoices.php',
  createArchiveOrder: host + 'archiveOrder.php',
  listArchiveOrders: host + 'getArchivedOrders.php',
  ocrDumpCollectionFetch: host + 'ocrDumpFetch.php',

  uploadCompanyFolder: 'companiesLogo',
  uploadTestimonialFolder: 'testimonial',
  uploadCompanyLogoandTestimonal: host + 'uploadCompanyLogoandTestimonal.php',

  bannerImagesUpload: host + 'bannerImageUpload.php',
  uploadedBannerImage: host + "bannerImages/",
  logoUploadUrl: host + "firmLogo.php",

  reportsUpload: host + 'reportsUpload.php',
}
export const roles = [
  {
    'label': 'Pro',
    'value': 'Pro'
  },
  {
    'label': 'Solution Estimate',
    'value': 'Solution Estimate'
  },
  {
    'label': 'Estimator',
    'value': 'Estimator'
  },
  {
    'label': 'Senior Estimator',
    'value': 'Senior Estimator'
  },
  {
    'label': 'Spekwo Manager',
    'value': 'Spekwo Manager'
  },
  {
    'label': 'speK ExeC',
    'value': 'speK ExeC'
  },
  {
    'label': 'Owner',
    'value': 'Owner'
  },
  {
    'label': 'File Onboarder',
    'value': 'File Onboarder'
  },
  {
    'label': 'QCA',
    'value': 'QCA'
  },
  {
    'label': 'Blue Team',
    'value': 'Blue Team'
  },

];

export const customerRoles = [
  {
    viewValue: 'Current Owner/Seller',
    value: '7fbea184-0a71-11ec-8dcc-1722801e9c5c'
  },
  {
    viewValue: 'Owner/Buyer',
    value: '97f57cc8-0a71-11ec-8c9e-d7e9efc7b97c'
  },
  {
    viewValue: 'Buyer Broker',
    value: 'af946e84-0a71-11ec-a1ac-c77b1631d3f6'
  },
  {
    viewValue: 'Seller Broker',
    value: 'c5573602-0a71-11ec-b562-cba27195b2b8'
  },
];

export const trashOrderStatus = {
  'wc-processing': 'processing',
  'wc-pending': 'pending',
  'wc-completed': 'completed',
  'wc-on-hold': 'on-hold',
  'wc-cancelled': 'cancelled',
  'wc-failed': 'failed'
}
export const agentRoles = [
  { viewValue: 'Buyer Broker', value: 'Buyer Broker' },
  { viewValue: 'Seller Broker', value: 'Seller Broker' },
  { viewValue: 'Buyer TM', value: 'Buyer TM' },
  { viewValue: 'Seller TM', value: 'Seller TM' },
];
export const clientRole = [
  { viewValue: 'Buyer', value: 'Buyer' },
  { viewValue: 'Seller', value: 'Seller' },
];

export const orderAgentRoles = [
  { value: 'Buyer Broker', key: 'BB' },
  { value: 'Seller Broker', key: 'SB' },
  { value: 'Buyer TM', key: 'BTM' },
  { value: 'Seller TM', key: 'STM' },
  { value: 'TC for buyer', key: 'TCB' },
  { value: 'TC for seller', key: 'TCS' },
  { value: 'Buyer', key: 'B' },
  { value: 'Seller', key: 'S' },
  { value: 'Listing Broker', key: 'LB' },
  { value: 'Buyers Agent', key: 'BA' },
  { value: 'Seller Agent', key: 'SA' },
  { value: 'Home Inspector', key: 'HI' },
  { value: 'Property Manager', key: 'PM' },
]

export const statusOrder = {
  initiate: 1,
  ready_to_estimate: 2,
  first_review: 3,
  second_review: 4,
  final_review: 5,
  se_complete: 6,
  work_requested: 7,
  cancel_work_request: 8
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/spekwo.ts